import { CreateEventFormData, CreateEventPayload } from "../../types/event/createEvent";

export const createEventService = {
    async createEvent(formData: CreateEventFormData): Promise<any> {
        // Calculate total tickets available from all tiers
        const totalTicketsAvailable = formData.ticket_tiers.reduce(
            (sum, tier) => sum + parseInt(tier.tickets_available.toString()), 
            0
        );

        const payload: CreateEventPayload = {
            ...formData,
            stripe_enabled: formData.stripe_enabled ? 1 : 0,
            e_transfer_enabled: formData.e_transfer_enabled ? 1 : 0,
            bursary_enabled: formData.bursary_enabled ? 1 : 0,
            date: formData.date,
            tickets_available: totalTicketsAvailable,
            time_start: formData.time_start,
            time_end: formData.time_end,
            event_organizers: [],
            bursary_options: formData.bursary_enabled && formData.bursary_type === 'fixed' 
                ? formData.bursary_options 
                : []
        };

        const response = await fetch(`${process.env.REACT_APP_API_URL}/events/`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            credentials: 'include',
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            const errorText = await response.text();
            try {
                const errorData = JSON.parse(errorText);
                throw new Error(errorData.message || 'Failed to create event');
            } catch (jsonError) {
                throw new Error(errorText);
            }
        }

        return response.json();
    }
}; 